import { BaseWebComponentRepository } from '../../../../framework/BaseWebComponentRepository';
import { CompanyDetailsTabDataProviderFactory } from '../factory/CompanyDetailsTabDataProviderFactory';
import { CompanyDetailsTabBaseDataProvider } from '../dataProvider/CompanyDetailsTabBaseDataProvider';
import { CompanyData } from '../../../types/company-data';

export class CompanyDetailsTabRepository extends BaseWebComponentRepository {
  public dataProviderFactory: CompanyDetailsTabDataProviderFactory;
  public dataProvider: CompanyDetailsTabBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new CompanyDetailsTabDataProviderFactory(),
    });
  }

  public async getMyCompanyData(): Promise<CompanyData> {
    return this.dataProvider.getMyCompanyData();
  }

  public async getManagedCompanyById(companyId: string): Promise<CompanyData> {
    return this.dataProvider.getManagedCompanyById(companyId);
  }
}
